export function toString(object) {
  const pairs = Object.keys(object).map((key) => {
    const value = encodeURIComponent(object[key]);
    return `${key}=${value}`;
  });

  return pairs.join('&');
}

export async function handleApiErrors(response) {
  const { status, textStatus, ok } = response;
  if (status !== 204) {
    const body = await response.text().then((t) => (t ? JSON.parse(t) : {}));

    if (!ok) {
      const error = new Error(
        body.error?.description ?? body.detail ?? textStatus ?? body.error
      );
      error.statusCode = status;
      error.key = body?.error?.key;
      error.description = body.error?.description ?? body.detail ?? body.error;
      throw error;
    }
    return body;
  }
  return null;
}

export default function ownFetch(url, method, body, customHeaders, options) {
  /*
   * This fetch function should be used only for core-api requests by now
   * It should be somehow more generic to work fine with other apis as well
   */
  let accountId = 'unknown';
  const account = JSON.parse(localStorage.getItem('account'));
  if (!url.includes('/login/')) {
    if (account !== null) accountId = String(account.id);
  }
  const data = {
    method,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      ...(url.includes('app') && { 'pos-account-id': accountId }),
    },
    mode: 'cors',
    body: body && toString(body),
  };

  if (customHeaders && customHeaders['Content-Type'] === 'application/json') {
    data.body = body ? JSON.stringify(body) : null;
  }

  data.headers = {
    ...data.headers,
    ...customHeaders,
  };

  return fetch(url, data).then((response) => {
    if (options && options.ignoreHandler) {
      return response;
    }
    return handleApiErrors(response);
  });
}
